import { AxiosInstance } from 'axios';

import {
  HibernationSchedulesAPIApiFactory,
  HibernationJobsAPIApiFactory,
  NodeTemplatesAPIApiFactory,
  PoliciesV2APIApiFactory,
  RebalancingConfigAPIApiFactory,
} from '@cast/openapi-cluster-autoscaler';

import { AXIOS_CONFIGURATION } from '../constants';

export const ClusterAutoscalerApiAdapter = (client: AxiosInstance) => {
  const newNodeTemplatesApi = NodeTemplatesAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );
  const hibernationSchedulesGeneratedApi = HibernationSchedulesAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );
  const hibernationJobsGeneratedApi = HibernationJobsAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  const rebalancingConfigGeneratedApi = RebalancingConfigAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  const policiesV2GeneratedApi = PoliciesV2APIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  return {
    getPoliciesV2: policiesV2GeneratedApi.policiesV2APIGetClusterPolicies,
    updatePoliciesV2: policiesV2GeneratedApi.policiesV2APIUpdateClusterPolicies,
    getHibernationSchedules:
      hibernationSchedulesGeneratedApi.hibernationSchedulesAPIListHibernationSchedules,
    deleteHibernationSchedule:
      hibernationSchedulesGeneratedApi.hibernationSchedulesAPIDeleteHibernationSchedule,
    createHibernationSchedule:
      hibernationSchedulesGeneratedApi.hibernationSchedulesAPICreateHibernationSchedule,
    updateHibernationSchedule:
      hibernationSchedulesGeneratedApi.hibernationSchedulesAPIUpdateHibernationSchedule,
    createHibernationJob:
      hibernationJobsGeneratedApi.hibernationJobsAPICreateHibernationJob,
    updateNodeTemplatesCapacityReservationConstraints:
      newNodeTemplatesApi.nodeTemplatesAPIUpdateCapacityReservationConstraints,
    listRebalancingNodeFilterValues:
      rebalancingConfigGeneratedApi.rebalancingConfigAPISearchRebalancingNodeFilterValues,
    listRebalancingNodeFilters:
      rebalancingConfigGeneratedApi.rebalancingConfigAPISearchRebalancingNodeFilters,
    listRebalancingNodes:
      rebalancingConfigGeneratedApi.rebalancingConfigAPISearchRebalancingNodes,
    listRebalancingWorkloads:
      rebalancingConfigGeneratedApi.rebalancingConfigAPISearchRebalancingWorkloads,
  };
};
